//
//
//
//
//
//
//

import PageMixin from '~/mixins/page'

export default {
  mixins: [
    PageMixin
  ],
  layout: 'logo',
  head () {
    return {
      ...this.createSeoTags({
        title: this.$t('practitioners.seo.title'),
        description: this.$t('practitioners.seo.description'),
        url: 'https://get-base.com/whitepaper',
        link: [
          {
            rel: 'preload',
            as: 'image',
            href: 'https://statics.get-base.com/affiliate/fixmydiet_header.webp'
          }
        ]
      })
    }
  }
}
